<template>
  <div></div>
</template>

<script>
export default {
  name: "Fastpay"
}
</script>

<style scoped>

</style>